<template>
    <div v-if="model">
        <b-row v-if="!executeQuery.show">
            <b-col cols="12" md="6">
                    <b-card no-body>
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-button block v-b-toggle.accordion-1 variant="primary">{{ $t('connectionSettings') }}</b-button>
                        </b-card-header>

                        <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-form-group
                                    :label="$t('id')"
                                    :description="$t('ratchetIdDescription')"
                                >
                                    <b-form-input v-model="connectionId" disabled></b-form-input>
                                </b-form-group>
                                <b-form-group
                                    :label="$t('type')"
                                >
                                    <v-select :options="connectionTypes" v-model="model.type" disabled/>
                                </b-form-group>
                                <b-form-group
                                    :label="$t('credentials')"
                                >
                                    <v-select :options="credentialsType" v-model="model.credentials.type" disabled/>
                                </b-form-group>

                                <template v-if="model.credentials.type == 'DSN'">
                                    <b-form-group
                                        label="DSN"
                                    >
                                        <b-form-input type="password" v-model="model.credentials.dsn" disabled/>
                                    </b-form-group>
                                </template>

                                <template v-if="model.credentials.type == 'Credentials'">
                                    <b-form-group
                                        label="User"
                                    >
                                        <b-form-input v-model="model.credentials.user" disabled/>
                                    </b-form-group>

                                    <b-form-group
                                        label="Password"
                                    >
                                        <b-form-input type="password" v-model="model.credentials.password" disabled/>
                                    </b-form-group>

                                    <b-form-group
                                        label="Host"
                                    >
                                        <b-form-input v-model="model.credentials.host" disabled/>
                                    </b-form-group>

                                    <b-form-group
                                        label="DB name"
                                    >
                                        <b-form-input v-model="model.credentials.dbname" disabled/>
                                    </b-form-group>
                                </template>
                            </b-card-body>

                            <b-card-footer>
                                <b-button variant="warning" @click="testConnection"> {{ $t('testConnection') }}</b-button>
                                <b-button variant="danger" class="ml-1" @click="remove"> {{ $t('remove') }}</b-button>
                            </b-card-footer>

                        </b-collapse>
                    </b-card>  
            </b-col>
            <b-col cols="12" class="mb-4"><b-button @click="newQuery">{{ $t('newQuery') }}</b-button></b-col>

            <b-col cols="12" md="3" v-for="query in model.queries" :key="query.id">
                <b-card>
                    <b-row>
                        <b-col cols="7">{{ query.id }}</b-col>
                        <b-col cols="5"> <b-icon icon="pencil" class="mr-2 action" @click="editAction(query)"/> <b-icon icon="trash" class="action mr-2" @click="removeQuery(query)"/> <b-icon icon="play" class="action" @click="tryQuery(query)"/></b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>

        <b-row v-if="executeQuery.show">
            <template v-if="model.type == 'MySQL' || model.type == 'PostgreSQL'">
                <b-col cols="12"><b-icon icon="arrow-left" @click="executeQuery.show = false"/></b-col>
                <b-col cols="12" class="mt-4"><b-button variant="success"><b-icon icon="play" @click="runQuery"/></b-button></b-col>
                <b-col cols="12" class="mt-4"><CodeEditor v-model="executeQuery.query" :withButton="false" /></b-col>
                <b-col cols="12">
                    <ol>
                        <li v-for="(param, index) in executeQuery.params" :key="index" class="mb-2">
                            <b-row>
                                <b-col cols="8">
                                    <b-input v-model="executeQuery.params[index]" />
                                </b-col>
                                <b-col cols="2">
                                    <b-icon icon="trash" class="action" @click="removeParam(index)"/>
                                </b-col>
                            </b-row>
                        </li>
                    </ol>
                    <b-button @click="addParam">{{ $t('addParam') }}</b-button>
                    <b-card v-if="executeQuery.results" class="mt-4">
                        <b-table dark striped hover responsive :items="executeQuery.results"  />
                    </b-card>
                </b-col>
            </template>

            <template v-if="model.type == 'MongoDB'">
                <b-col cols="12"><b-icon icon="arrow-left" @click="executeQuery.show = false"/></b-col>
                <b-col cols="12" class="mt-4"><b-button variant="success"><b-icon icon="play" @click="runQuery"/></b-button></b-col>
                <b-col cols="12" class="mt-4"><CodeEditor v-model="executeQuery.query" :withButton="false" /></b-col>
                <b-col cols="12">
                    <b-col cols="12"><small><a href="https://www.mongodb.com/docs/manual/reference/command" target="_blank">MongoDB command documentation</a></small></b-col>
                    <b-card v-if="executeQuery.results" class="mt-4">
                        <b-table dark striped hover responsive :items="executeQuery.results"  />
                    </b-card>
                </b-col>
            </template>
        </b-row>

        <b-sidebar v-model="edit.active" right :title="edit.query.id">
            <CodeEditor v-model="edit.query.expression" :withButton="false" class="p-2"/>

            <template #footer>
                <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
                    <b-button size="sm" variant="success" @click="editQuery"> {{ $t('edit') }} </b-button>
                </div>
            </template>
        </b-sidebar>

        <b-sidebar v-model="create.active" right>
            <div class="p-2">
                <b-form-group
                    :label="$t('id')"
                >
                    <b-form-input v-model="createQueryId"></b-form-input>
                </b-form-group>
                <CodeEditor v-model="create.query.expression" :withButton="false"/>
            </div>

            <template #footer>
                <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
                    <b-button size="sm" variant="success" @click="saveQuery"> {{ $t('save') }} </b-button>
                </div>
            </template>
        </b-sidebar>
    </div>

    <b-skeleton v-else width="100%" height="250px" animation="throb"></b-skeleton>
</template>

<script>
import VSelect from 'vue-select'
import CodeEditor from '@/components/form/Editor/Code.vue'
export default {
    name: "CreateRatchet",
    components: {
        VSelect,
        CodeEditor
    },
    data: function() {
        return {
            model: null,
            connectionTypes: ['MySQL', 'PostgreSQL', 'MongoDB'],
            credentialsType: ['DSN', 'Credentials'],

            edit: {
                active: false,
                query: {
                    id: '',
                    expression: null
                }
            },

            create: {
                active: false,
                query: {
                    id: '',
                    expression: null
                }
            },

            executeQuery: {
                show: false,
                query: '',
                params: [],
                results: null
            }
        }
    },

    computed: {
        createQueryId: {
            get() {
                return this.create.query.id.replaceAll(" ", "_")
            },

            set(v) {
                this.create.query.id = v.replaceAll(" ", "_")
            }
        },

        connectionId:{
            get() {
                return this.model.id.replaceAll(" ", "_")
            },

            set(v) {
                this.model.id = v.replaceAll(" ", "_")
            }
        },
    },

    methods: {
        editAction(query) {
            this.edit.active = true
            this.edit.query = query
        },

        async editQuery() {
            let q = this.model.queries.find(query => query.id == this.edit.query.id)
            q.expression = this.edit.query.expression

            this.edit.active = false
            this.edit.query = {
                id: '',
                expression: null
            }

            this.save()
        },

        async removeQuery(q) {
            let confirm = await this.$bvModal.msgBoxConfirm(`${this.$t('areYouSure')}?`)
            if (!confirm) return

            this.model.queries = this.model.queries.filter(query => query.id != q.id)
            this.save()
        },

        newQuery() {
            this.create.active = true
        },

        saveQuery() {
            let queries = this.model.queries || []

            queries.push(this.create.query)

            this.create.active = false
            this.create.query = {
                id: '',
                expression: null
            }

            this.model.queries = queries

            this.save()
        },

        testConnection() {
            this.$ratchetApi.post("/test/connection", this.model).then(resp => {
                this.$bvToast.toast(this.$t('connectionEstablished'), {
                    title: this.$t('success'),
                    variant: 'success'
                })
            }).catch(err => {
                this.$bvToast.toast(err.response.data.message, {
                    title: this.$t('error'),
                    variant: 'danger'
                })
            })
        },

        save() {
            let popup = this.$loadingPopup()
            this.$ratchetApi.put("/connection", this.model).catch(err => {
                this.$bvToast.toast(err.response.data.message, {
                    title: this.$t('error'),
                    variant: 'danger'
                })
            }).finally(() => {
                popup.hide()
            })
        },

        async remove() {
            let confirm = await this.$bvModal.msgBoxConfirm(this.$t('areYouSure'))
            if (!confirm) return

            let popup = this.$loadingPopup()
            this.$ratchetApi.delete("/connection/" + this.model.id)
            .then(() => {
                this.$router.push("/admin/ratchet")
            })
            .catch(err => {
                this.$bvToast.toast(err.response.data.message, {
                    title: this.$t('error'),
                    variant: 'danger'
                })
            }).finally(() => {
                popup.hide()
            })
        },

        tryQuery(q) {
            this.executeQuery.show = true
            this.executeQuery.query = q.expression
        },

        addParam() {
            this.executeQuery.params.push(null)
        },

        removeParam(i) {
            this.executeQuery.params.splice(i, 1)
        },

        runQuery() {
            let popup = this.$loadingPopup()
            this.$ratchetApi.post("/query/inspect", {
                name: this.model.id,
                query: {
                    expression: this.executeQuery.query
                },
                params: this.executeQuery.params
            }).then(resp => {
                this.executeQuery.results = resp.data
            })
            .catch(err => {
                this.$bvToast.toast(err.response.data.message, {
                    title: this.$t('error'),
                    variant: 'danger'
                })
            }).finally(() => {
                popup.hide()
            })
        }
    },

    mounted() {
        this.$ratchetApi.get("/connection/" + this.$route.params.id).then(resp => {
            this.model = resp.data
        }).catch(err => {
            this.$bvToast.toast(err.response.data.message, {
                title: this.$t('error'),
                variant: 'danger'
            })
        })
    }
}
</script>

<style scoped>
.action {
    cursor: pointer;
}

.action:hover {
    color: #ccc;
}

</style>